import { z } from 'zod';

import { CharacterSchema } from './character.types.ts';
import { LessonSchema } from './lesson.types.ts';
import { LetterSchema } from './letter.types.ts';
import { ScriptsSchema } from './script.types.ts';
import { WordSchema } from './word.types.ts';
import { WritingPathStyle, WritingPathSchema } from './writing-path.types.ts';

// Collection schemas
export const WordsSchema = z.record(WordSchema);
export const LettersSchema = z.record(LetterSchema);
export const CharactersSchema = z.record(CharacterSchema);
export const LetterWritingPathsSchema = z.record(
  z.nativeEnum(WritingPathStyle),
  z.record(z.string().describe('The letter key'), WritingPathSchema)
);
export const LessonsSchema = z.record(LessonSchema);

// Type exports
export type Lessons = z.infer<typeof LessonsSchema>;
export type Words = z.infer<typeof WordsSchema>;
export type Letters = z.infer<typeof LettersSchema>;
export type Characters = z.infer<typeof CharactersSchema>;
export type LetterWritingPaths = z.infer<typeof LetterWritingPathsSchema>;
export type Scripts = z.infer<typeof ScriptsSchema>;

export const AssetsFileSchema = z.object({
  words: WordsSchema,
  letters: LettersSchema,
  'animal-characters': CharactersSchema,
  'writing-paths': LetterWritingPathsSchema,
  lessons: LessonsSchema,
  scripts: ScriptsSchema,
});

export type AssetsFile = z.infer<typeof AssetsFileSchema>;

export abstract class BaseLoaderUtil {
  abstract load(assets: AssetsFile): Promise<void> | void;
}
